import { render, staticRenderFns } from "./vip1.vue?vue&type=template&id=789e13a0&scoped=true"
import script from "./vip1.vue?vue&type=script&lang=js"
export * from "./vip1.vue?vue&type=script&lang=js"
import style0 from "./vip1.vue?vue&type=style&index=0&id=789e13a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789e13a0",
  null
  
)

export default component.exports